import { Button, Head, useAuth } from "zudoku/components";
import { FullScreen } from "./FullScreen";

export const LoggedOutPage = () => {
  const auth = useAuth();

  return (
    <FullScreen>
      <Head>
        <title>Signed out</title>
      </Head>
      <h1 className="text-xl font-semibold">You have been signed out</h1>
      <p className="text-muted-foreground">
        Sign in again to continue to the Finarkein docs.
      </p>
      <Button onClick={() => void auth.login({ redirectTo: "/" })}>
        Sign in again
      </Button>
    </FullScreen>
  );
};
